/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const RuleEffect = {
    Include: 'Include',
    Exclude: 'Exclude'
} as const;
export type RuleEffect = typeof RuleEffect[keyof typeof RuleEffect];

